<template>
    <div class="role-list">
        <el-main class="pageMain">
            <div class="fixedHeader">
                <template v-if="userType==1">
                    <el-button type="primary" size="mini" class="btnStyle" @click="toDetail(0)">单个添加</el-button>
                    <el-button type="info" size="mini" class="btnStyle" disabled title="暂无功能">批量导入</el-button>
                    <el-button type="info" size="mini" class="btnStyle" disabled title="暂无功能">列表导出</el-button>
                </template>
                <template v-else>
                    类型用户管理
                </template>
                <div class="rightBox">
                    <el-button type="success" size="mini" class="btnStyle" @click="batchEnableOrDisable(1)"> 批量启用</el-button>
                    <el-button type="warning" size="mini" class="btnStyle" @click="batchEnableOrDisable(2)"> 批量停用 </el-button>
                    <el-button type="primary" size="mini" class="btnStyle" @click="toDetail(4)" v-if="userData.organizationId">设置用户</el-button>
                    <el-button type="primary" size="mini" class="btnStyle" @click="toDetail(1)">编辑</el-button>
                    <el-button type="primary" size="mini" class="btnStyle" @click="toDetail(3)">设置权限</el-button>
                    <el-button type="danger" size="mini" class="btnStyle" @click="toDetail(2)" v-if="userType==1">删除</el-button>
                </div>
            </div>
            <!--列表区-->
            <div>
                <el-table
                        :data="roles"
                        style="width: 100%;margin-bottom: 20px;"
                        stripe
                        row-key="id"
                        ref="table"
                        @select-all="memberSelect"
                        @select="memberSelect" border>
                    <el-table-column type="selection" :reserve-selection="true" width="55"
                                     align="center"></el-table-column>
                    <el-table-column label="序号" type="index" width="50" fixed align="center"></el-table-column>
                    <el-table-column prop="enable" label="角色状态" width="110px" sortable>
                      <template slot-scope="scope">
                        <span class="status-color" :class="'active-status-' + scope.row.enable">{{scope.row.enable === 1 ? '已启用' : '已停用'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" :label="userType==1?'系统角色名称':'用户角色名称'" sortable></el-table-column>
                    <el-table-column prop="description" label="角色描述" sortable></el-table-column>
                </el-table>
            </div>
        </el-main>

        <!--添加编辑弹窗-->
        <el-dialog v-dialogDrag :title="this.form.id > 0 ? '编辑' : '添加'" :visible.sync="editing" width="700px" center>
            <el-form ref="form_role" :model="form" :rules="rules" label-width="90px">
                <el-form-item label="角色名称" prop="name">
                    <el-input v-model.trim="form.name" autocomplete="off" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="角色描述" prop="description">
                    <el-input v-model="form.description" autocomplete="off" maxlength="80" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="editing = false" :disabled="loading">取 消</el-button>
                <el-button type="primary" size="mini" @click="save()" :loading="loading">确 定</el-button>
            </span>
        </el-dialog>
        <!--设置用户弹窗-->
        <el-dialog v-dialogDrag title="设置用户" :visible.sync="userListDialog" width="700px" center class="userListDialog">
            <el-row>
                <el-col :span="12" v-if="departs">
                    请选择部门查询用户
                    <el-tree
                            :data="departs"
                            node-key="id"
                            @current-change="selectDept"
                            default-expand-all
                            :expand-on-click-node="false">
                        <div class="custom-tree-node" slot-scope="{ node, data }">
                            <div class="custom-tree-role"
                                 :title="data.name"
                            ><i class="el-icon-house"></i> {{ data.name }}</div>
                        </div>
                    </el-tree>
                </el-col>
                <el-col :span="departs?12:24">
                    用户列表：
                    <el-checkbox-group v-model="userIdArr">
                        <el-checkbox v-for="(item,index) in userList" :label="item.userId" :key="index">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="userListDialog = false" :disabled="loading">取 消</el-button>
                <el-button type="primary" size="mini" @click="saveUserRole()" :loading="loading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {roleApi} from "@/api/organization";
    import {deptApi, userApi} from "../../api/organization";
    import * as stream from "stream";

    export default {
      name:"Sys_Role",
        data() {
            return {
                loading: false,
                roles: [],
                editing: false,
                form: {},
                allSelected: [],
                rules: {
                    name: [{required: true, message: "请输入角色名称", trigger: "blur"}],
                    description: [{required: true, message: "请输入角色描述", trigger: "blur"}]
                },
                userListDialog: false,
                userList: [],
                userIdArr: [],  //选中的用户
                activeRole: [],  //选中的角色
                userType: 0,  //系统角色  1用户定义角色
                userData: null,
                departs: null,  //树
                deptId: "",
            };
        },
        created() {
            this.userData = this.$store.state.AuthedUser;
            if(this.$route.name == "Sys_Admin_Role"){
              this.userType = 0;
          }else{
              this.userType = 1;
          }
            this.listRoles();
        },
        methods: {
            batchEnableOrDisable(enable){
              const dataArr = this.allSelected;
              if(dataArr.length == 0){
                this.$message.error("请先勾选");
                return;
              }
              const names = dataArr.flatMap((e) => e.name);
              this.$confirm('确认要' + (enable === 1 ? '启用' : '停用')+'【' + names.join("，")+ '】角色吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                roleApi.batchEnableOrDisable(dataArr.flatMap((e) => e.id).join(","), enable).then((r) => {
                  if(r.data.result === 0){
                    this.$message.success("操作成功");
                    this.listRoles();
                  }
                });
              });
            },
            memberSelect(selection, row) {
                this.allSelected = selection;
            },
            // type 4设置用户
            toDetail(type) {
                const dataArr = this.allSelected;
                if(type !== 0){
                    if(dataArr.length == 0){
                        this.$message.error("请先勾选");
                        return;
                    }
                    if(dataArr.length > 1){
                        this.$message.error("只能勾选一个角色");
                        return;
                    }
                    if(type === 1){
                        this.updateRole(dataArr[0]);
                    }else if(type === 2){
                        this.deleteRole(dataArr[0]);
                    }else if(type === 3){
                        this.updateRights(dataArr[0]);
                    }else if(type === 4){
                        this.setUserRole(dataArr[0]);
                    }
                }else{
                    this.addRole();
                }

            },
            //设置用户******************************************
            setUserRole(role){
                this.activeRole = role;
                if(this.userData.organizationId){
                    deptApi.tree(null).then((r)=>{
                        if(r.data.result === 0){
                            this.departs = r.data.data;
                            this.userListDialog = true;
                            this.$nextTick(()=>{
                                if(this.departs.length > 0){
                                    this.selectDept(this.departs[0]);
                                }
                            })
                        }
                    });
                }else{
                    this.getUserList();
                }
            },
            saveUserRole(){
                userApi.saveRoleUser({
                    userIds: this.userIdArr.join(","),
                    roleId: this.activeRole.id
                }).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("保存成功");
                        this.userListDialog = false;
                    }
                })
            },
            selectDept(data){
                this.deptId = data.id;
                this.getUserList();
            },
            getUserList(){
                const depart = this.departs.find(t => t.id === this.deptId);
                if (depart && depart.parentId === 0) {
                    this.deptId = "";
                }
                const role = this.activeRole;
                userApi.listRoleUser({roleId: role.id, deptId: this.deptId}).then(r => {
                    if (r.data.result === 0) {
                        const rData = r.data.data;
                        if(rData.length > 0){
                            this.userList = rData;
                            this.userIdArr = [];
                            rData.forEach(e=>{
                                if(e.currentRole){
                                    this.userIdArr.push(e.userId);
                                }
                            })
                        }else{
                            this.userList = [];
                            this.userIdArr = [];
                            this.$message.warning("暂无用户");
                        }
                    }
                })
            },
            //设置用户end******************************************
            listRoles() {
                roleApi.list(this.userType, undefined).then(r => {
                    if (r.data.result === 0) {
                        this.roles = r.data.data;
                        this.$nextTick(()=>{
                            let $table = this.$refs.table;
                            if($table){
                                $table.doLayout();
                            }
                        })
                    }
                })
            },
            deleteRole(role) {
                this.$confirm("确实要删除角色【" + role.name + "】吗?", "确认操作", {type: "warning"})
                    .then(() => {
                        roleApi.delete(role.id).then(r => {
                            if (r.data.result === 0) {
                                this.$message.success("删除角色成功");
                                this.allSelected = [];
                                this.$refs.table.clearSelection();
                                this.listRoles();
                            }
                        })
                    })
            },
            addRole() {
                this.editing = true;
                this.$nextTick(() => {
                    this.$refs['form_role'].resetFields();
                    this.form = {};
                });
            },
            updateRole(role) {
                this.editing = true;
                this.$nextTick(() => {
                    this.$refs['form_role'].resetFields();
                    this.form = Object.assign({}, role, {roleResources: null});
                });
            },
            updateRights(role) {
                this.$router.push({path: '/sys/role/resource/' + role.id})
            },
            save() {
                this.$refs['form_role'].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        let request;
                        this.form.userType = this.userType;
                        if (this.form.id) {
                            request = roleApi.update((this.form))
                        } else {
                            request = roleApi.add(this.form)
                        }

                        request.then(r => {
                            this.loading = false;
                            if (r.data.result === 0) {
                                this.editing = false;
                                this.listRoles();
                            }
                        }).catch(() => {
                            this.loading = false;
                        })
                    } else {
                        return false;
                    }
                });
            }
        }
    };
</script>
<style lang="scss">
    .role-list {
        .el-main {
            .clearfix:before,
            .clearfix:after {
                display: table;
                content: "";
            }

            .clearfix:after {
                clear: both;
            }

            .box-card {
                width: 380px;
                display: inline-block;
                margin: 10px;
                vertical-align: top;

                .representBox {
                    height: 37px;
                    line-height: 17px;
                    white-space: initial;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    word-break: break-all;
                    color: #606266;
                }
            }
        }
        .userListDialog{
            .el-checkbox{
                width: 100px;
            }
        }
    }

</style>
